function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "transfer",
  transform: "translate(7.778 8.545)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11647",
  "data-name": "Path 11647",
  d: "M25.08,16.08l1.591,1.591,8.107-8.108L26.67,1.455,25.079,3.046l5.392,5.392H1.125v2.25H30.471L25.079,16.08Z",
  transform: "translate(6 -10)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11648",
  "data-name": "Path 11648",
  d: "M34.875,25.313H5.529l5.392-5.392L9.33,18.33,1.222,26.438,9.33,34.546l1.591-1.591L5.529,27.563H34.875Z",
  transform: "translate(-9 6)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "money",
  d: "M5.382,7.5H24.437a2.382,2.382,0,0,1,2.382,2.382V21.791a2.382,2.382,0,0,1-2.382,2.382H5.382A2.382,2.382,0,0,1,3,21.791V9.882A2.382,2.382,0,0,1,5.382,7.5ZM22.055,9.882H7.764a2.382,2.382,0,0,1-2.382,2.382v7.146a2.382,2.382,0,0,1,2.382,2.382H22.055a2.382,2.382,0,0,1,2.382-2.382V12.264A2.382,2.382,0,0,1,22.055,9.882ZM10.146,12.264h2.382v7.146H10.146Zm7.146,4.764A1.191,1.191,0,1,0,16.1,15.836,1.191,1.191,0,0,0,17.291,17.027Zm0,2.382a3.573,3.573,0,1,1,3.573-3.573A3.573,3.573,0,0,1,17.291,19.409Z",
  transform: "translate(1.216 0.119)",
  fill: "#ac1ede"
}));

var SvgTransfer = function SvgTransfer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48.556,
    height: 49.091,
    viewBox: "0 0 48.556 49.091",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTransfer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transfer.299b0456.svg";
export { ForwardRef as ReactComponent };